import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function WhoWeServeSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation({ threshold: 0.3 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation({ threshold: 0.2 });

  const clients = [
    {
      icon: 'ri-hospital-line',
      label: 'Hospitals',
      desc: 'Acute care & trauma centers'
    },
    {
      icon: 'ri-building-line',
      label: 'Imaging Centers',
      desc: 'Outpatient diagnostic facilities'
    },
    {
      icon: 'ri-community-line',
      label: 'Health Systems',
      desc: 'Multi-facility networks'
    },
    {
      icon: 'ri-heart-pulse-line',
      label: 'Critical Access',
      desc: 'Rural & underserved facilities'
    }
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 bg-navy overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div
          ref={headerRef}
          className={`text-center mb-10 sm:mb-16 transition-all duration-700 ease-out ${
            headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <p className="text-white/50 text-[13px] uppercase tracking-[2px] font-medium mb-3">
            WHO WE SERVE
          </p>
          <h2 className="text-white text-[24px] sm:text-[30px] lg:text-[38px] font-semibold leading-tight max-w-3xl mx-auto">
            Trusted by Healthcare Organizations That Need Equipment, Not Operators
          </h2>
          <p className="text-white/60 text-base sm:text-lg mt-4 max-w-2xl mx-auto leading-relaxed">
            We lease imaging equipment to facilities that have their own clinical teams and simply need the hardware, infrastructure, and maintenance support.
          </p>
        </div>

        {/* Grid */}
        <div ref={gridRef} className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {clients.map((client, index) => (
            <div
              key={index}
              className={`flex flex-col items-center text-center group cursor-pointer transition-all duration-500 ease-out ${
                gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: gridVisible ? `${index * 100}ms` : '0ms' }}
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border-2 border-white/30 flex items-center justify-center mb-4 sm:mb-5 transition-all duration-500 group-hover:bg-slate-blue group-hover:border-slate-blue group-hover:scale-110">
                <i className={`${client.icon} text-white text-[28px] sm:text-[36px]`}></i>
              </div>
              <h3 className="text-white text-[15px] sm:text-[18px] font-semibold mb-1">
                {client.label}
              </h3>
              <p className="text-white/55 text-xs sm:text-sm">
                {client.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Key Message */}
        <div
          className={`max-w-3xl mx-auto text-center p-6 sm:p-8 bg-white/5 border border-white/10 rounded-2xl transition-all duration-700 ease-out delay-400 ${
            gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <p className="text-white text-lg sm:text-xl font-light leading-relaxed">
            &ldquo;Expand your imaging capacity without capital investment. Lease the equipment, keep full operational control.&rdquo;
          </p>
        </div>
      </div>
    </section>
  );
}
